import React from "react";
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import style from "../../Styles/Components/Scratch.module.css";
import {ScratchObject, Mask} from "./scratch";
import {withTranslation} from "react-i18next";
//component
// import  from "./";

class Scratch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
      isTriggered: false,
      localEvent: this.props.localEvent || {},
      eventPrize: this.props.eventPrize || {},
    };
  }

  cancelAnimFrame(){
    return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || function (id) { window.clearTimeout(id)}
  }

  requestAnimFrame(){
    return window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) { setTimeout(callback, 1000/60); };
  }

  componentDidMount() {
    this.scratchInit();
  }

  render() {
    const { localEvent = {}, eventPrize = {}, handleResultModal = null } = this.props;

    return (
      <div className={style.container}>
        <div id="scratchcard" className={style.scratchcard}>
          <span className={style.backgroundTitle} style={this.state.isOpened ? {color:"#ff7d40"} : {}}>{this.state.description}</span>
          <div className={style.background}>
          </div>
          <div id="scratch_01" className={style.scratch}></div>
          <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/coin.png"}
              srcSet={"https://d15eixcc3515pq.cloudfront.net/Assets/img/coin@2x.png 2x,https://d15eixcc3515pq.cloudfront.net/Assets/img/coin@3x.png 3x"}
              className={style.coin}></img>
        </div>
      </div>
    );
  }


  scratchInit(){
    var container = document.getElementById('scratchcard');
    let { t } = this.props;
    var scratch = new ScratchObject({
      w:244,h:157,
      src:this.state.eventPrize.image,
      text:this.state.eventPrize.name,
      detail: this.state.eventPrize.EPrizeType == 'void' ? t('lotto_void_message') : this.state.eventPrize.detail,
      type: this.state.eventPrize.EPrizeType
    });
    var canvas = scratch.canvas;
    var ctx = scratch.ctx;
  
    scratch.append("scratch_01");
  
    var w = canvas.width;
    var h = canvas.height;

    const init = () => {
      if ('ontouchstart' in window) {
        container.addEventListener('touchstart', onTouchStart,false);
        container.addEventListener('touchend', onTouchEnd,false);
      } else {
        container.addEventListener('mousedown', onTouchStart,false);
        container.addEventListener('mouseup', onTouchEnd,false);
      }
      const aniFrame = this.requestAnimFrame()
    }
    window.addEventListener('load', init, false);
  
    const animation = () => {
      if (this.state.isOpened) {
        return;
      }

      const aniFrame = this.requestAnimFrame()
      this.aniId = aniFrame(animation);
      scratch.clear(ctx);
      scratch.draw(ctx);
      
      if (scratch.getDisplayRate() > 70 && !this.state.isOpened) {
        this.setState({
          isOpened: true,
          description: "당첨!"
        }, () => {
          if (this.props.handleResultModal) {
              this.props.handleResultModal();
          }
        })
      }
    };
    const onTouchStart = (e) => {
      if (!this.props.checkIsLogin()) {
          return;
      }
      e.preventDefault();
      var event_trigger = ('ontouchstart' in window) ? 'touchmove' : 'mousemove';
      canvas.addEventListener(event_trigger, onTouchMove, false);
      animation();
    }
    const onTouchMove = (e) => {
      e.preventDefault();
        if (!this.state.isTriggered) {
            this.props.eventSubmit();
            this.setState({ isTriggered: true })
        }
      var offsetX = canvas.getBoundingClientRect().left;
      var offsetY = canvas.getBoundingClientRect().top;
      var p = ('ontouchstart'in window) ? e.touches[0] : e;
      var x = p.pageX - offsetX;
      var y = p.pageY - offsetY;
      scratch.addMask(new Mask(x,y,20));
    }
    const onTouchEnd = (e) => {
      e.preventDefault();
      var event_trigger = ('ontouchstart' in window) ? 'touchmove' : 'mousemove';
      canvas.removeEventListener(event_trigger, onTouchMove, false);
      const cancelAnim = this.cancelAnimFrame();
      cancelAnim(this.aniId);
    }

    init();
  }
}

export default connect()(withRouter(withTranslation()(Scratch)));
